import player from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';

export const LOTTIE_PROVIDER = 
    provideLottieOptions({
        player: () => player
    }) 
;
